export default __webpack_public_path__ + "static/media/18.eb618407.png";